import {extractYouTubeId,fawryCheckout,debounceFunc,VALIDATIONS,i18n,getCurrentLocation, useLocalStorage, isTokenValid, APIREQUESTS, MAINROLES, SPECIFICROLES, ROUTESNAMES, lowerString, arabizeNumbers , toArabicNumber } from '@/helpers';
import { useToast } from 'vue-toast-notification';
import axios from 'axios';
import { useGlobalStore } from '@/store/Modules/global';
import roundedPlaceholderImg from '@/assets/images/shopping-lo.png';
import rectanglePlaceholderImg from '@/assets/images/rectangle-placeholder.png';
import { mapState } from "pinia";
const $toast = useToast();

// NOTE: this file will not be accessed on the server side

import notificationIcon from '@/assets/navBar/notification.svg'; // Adjust the path to your icon
export const globalMixin = {
  data() {
    return {
      VALIDATIONS,
      ROUTESNAMES,
      APIREQUESTS,
      MAINROLES,
      SPECIFICROLES,
      contentModal:false,
      archivedModal:false,
      archivedProductByAdminModal:false,
      orderProductRemovedByUserModal:false, 
      orderProductRemovedByResellerModal:false,
      generalNotificationModal:false,
      withdrawalRequestModal:false,
      withdrawalNotificationModal:false,
    };
  },
  computed: {
    ...mapState(useGlobalStore, {
      global: (store) => store,
      isRTL: store => store?.localStorageCopy?.language == "ar",
      currentlySelectedLanguage: store => store?.localStorageCopy?.language || "ar",
      isUserLoggedIn: store => isTokenValid(store?.localStorageCopy?.user?.token),
      isAdminLoggedIn: store => isTokenValid(store?.localStorageCopy?.admin?.token)
    }),
    nameKey() {
      const globalStore = useGlobalStore();
      const isArabic = globalStore?.localStorageCopy?.language === 'ar';
      return `name_${isArabic ? 'ar' : 'en'}`;
    },
    descriptionKey(){
      const globalStore = useGlobalStore();
      const isArabic = globalStore?.localStorageCopy?.language === 'ar';
      return `description_${isArabic ? 'ar' : 'en'}`;
    },
    anyKey(){//to get name in ar or en depend on current language of app
      
      const globalStore = useGlobalStore();
      const isArabic = globalStore?.localStorageCopy?.language === 'ar';
      return anyName=> `${anyName}_${isArabic ? 'ar' : 'en'}`;
    },
  },
  methods:{
    isTokenValid,
    useLocalStorage,
    getCurrentLocation,
    lowerString,
    arabizeNumbers,
    toArabicNumber,
    fawryCheckout,
    extractYouTubeId,
    changeTawkVisibility(showIt){
      const chatContainer = document.querySelector('.widget-visible');
      const route = useRoute();
      if(chatContainer && (showIt ? route.fullPath === ROUTESNAMES.user.homepage : true)){
        chatContainer.style.setProperty("display", showIt ? "block" :"none", "important");
      }
    },
    changeLayoutDirection(name, lang) {
      useHead({
        htmlAttrs:{
          dir: name,
          lang
        }
      });
      const body = document.querySelector('body');
      body.setAttribute('direction', name);
      let html = document.querySelector('html');
      html.style.fontFamily = lang === 'ar' ? `'Kufi', Helvetica, sans-serif` : `'Quicksand', Helvetica, sans-serif`;
      html.className = name;
    },
    notify: ({ type, msg, time=5000, isQueue=true, handleClick=()=>{}}) => {
      if(type === 'clear'){
        $toast.clear();
        return;
      }

      if(!msg){
        console.error('A message must be provided.');
        return;
      }

      $toast.open({
        type: type,//One of success, info, warning, error, default
        message: msg,
        duration: time,
        position: "bottom-right",
        queue	:isQueue,

        onClick:handleClick,
        ...type=='notification'&&
        {style: {
          color: 'white',
          backgroundColor:'#b8b6b6',
          textAlign:'start',
          border:'1px solid #9e9e9e',
          borderRadius:'10px'
        }},
      });
      
      //add custom icon manually
      let toast__icon= document.querySelector('.v-toast .v-toast__item .v-toast__icon')
      let toast__pending= document.getElementsByClassName('v-toast--pending') //when isQueue=true
      if(type=='notification'){
        toast__icon.style.backgroundImage=` url(${notificationIcon})`// in url import icon as code not as path
        if(toast__pending.length){
          debounceFunc(()=>{
            if(toast__pending.length){}
            for (let i = 0; i< toast__pending.length; i++) {
              toast__pending[i].childNodes[0].childNodes[0].style.backgroundImage=` url(${notificationIcon})`
            }
          },800)()
        }

      }
    },

    log(...args) {
      if (process.env.NODE_ENV == 'production') {
        return;
      }
      return console.log(...args);
    },
    checkImageDimentionsAndExtension(selectedFile) {
      return new Promise((resolve, reject) => {
        if (selectedFile) {
        
          if (['image/jpeg', 'image/png', 'image/jpg'].includes(selectedFile.type)) {
            const image = new Image();
            image.src = URL.createObjectURL(selectedFile);
            image.onload = () => {
              // Check if the image meets the size requirement
              // if (image.width >= 647 && image.height >= 647) {
                // The image is valid;
                const previewImg = window.URL.createObjectURL(
                  new Blob([selectedFile], { type: "image/png" })
                );
                resolve(previewImg);
              // } else {
              //   this.notify({
              //     type: 'error',
              //     msg: i18n.global.t('general.image_dimensions_error'),
              //   });
                // reject(i18n.global.t('general.image_dimensions_error'));
              // }
            };

          } else {
            this.notify({
              type: 'error',
              msg: i18n.global.t('general.image_with_wrong_extension'),
            });
            reject(i18n.global.t('general.image_with_wrong_extension'));
          }
        } else {
          reject(i18n.global.t('general.image_doest_not_exist'));
          this.notify({
            type: 'info',
            msg: i18n.global.t('general.image_doest_not_exist'),
          });
        }
      });
  },
    async makeRequest({ specificRole, owner, method, url, formData = {}, withFiles = false, arrayBufferResponse = false,abortControllerSignal=null, includeUID = false }) {
      if (!url || !method) {
        console.error('Both the URL and the method must be provided.');
        return Promise.reject({});
      }
      // check network
      if(!navigator.onLine){

        console.error(i18n.global.t('general.not_online') );      
        return Promise.reject({
          data: {
            message: i18n.global.t('general.not_online') 
          }
        });
      }

      const authRequired = !!owner;
      const globalStore = useGlobalStore();
      // const errorMsg = 'An error occurred. Please try again later.';
      owner = lowerString(owner);
      const lsCopy = useLocalStorage({ type: 'get' });
      // gets all tokens from the local storage

      const userToken = lsCopy?.user?.token || globalStore.localStorageCopy?.user?.token;
      const adminToken = lsCopy?.admin?.token || globalStore.localStorageCopy?.admin?.token;

      const currentUserType = lsCopy?.user?.role || globalStore.localStorageCopy?.user?.role;
      const currentAdminType = lsCopy?.admin?.role || globalStore.localStorageCopy?.admin?.role;

      const redirectAndReset = () => {
        const mainRoleType = owner;
        this.useLocalStorage({
          type: 'set',
          value: {},
          key: mainRoleType,
        });
        if(mainRoleType === MAINROLES.user){
          this.$router?.push(ROUTESNAMES.user.login);
        }else if(mainRoleType === MAINROLES.admin){
          if(currentAdminType === SPECIFICROLES.reseller || SPECIFICROLES.moderator_reseller){
            this.$router.push({path: ROUTESNAMES.user.login});
          }else{
            this.$router?.push(ROUTESNAMES.panel.login);
          }
        }
      }
      let activeToken = '';
      if(authRequired){
          switch (owner) {
            case MAINROLES.user: // if user main type
              activeToken = userToken;
              // checks token & the role of the user
              if ((specificRole ? (lowerString(specificRole) !== lowerString(currentUserType)) : false) || (!this.isTokenValid(userToken))) {
                redirectAndReset();
                return Promise.reject({data: {
                  message: i18n.global.t('general.not_authorized')
                }});
              } else {
                break;
              }
            case MAINROLES.admin: // else if admin main type
              activeToken = adminToken;
              // checks token & the role of the admin
              if ((specificRole ? (lowerString(specificRole) !== lowerString(currentAdminType)): false) || (!this.isTokenValid(adminToken))) {
                redirectAndReset();
                return Promise.reject({data: {
                  message: i18n.global.t('general.not_authorized')
                }});
              } else {
                break;
              }
            default: {
              activeToken = '';
              return Promise.reject({});
            }
          }
      } 
        const cookieUID = includeUID ? useCookie?.("UID")?.value : false;

        const config = useRuntimeConfig();
        let baseURL = (process.env.NODE_ENV === "development" ? config.public.dev_base : config.public.prod_base) || 'http://localhost:3000';
        return axios({
          method,
          timeout: 60000,
          url,
          baseURL: baseURL + '/',
          ...(formData && { data: formData }),           
          ...(arrayBufferResponse && {
            responseType: 'arraybuffer'
          }),
          headers: {
            'Accept': 'application/json',
            'Platform': 'web',
            'Content-Type': withFiles ? 'multipart/form-data' : 'application/json',
            'Accept-Language': lsCopy?.language || globalStore.localStorageCopy?.language,
            ...(authRequired &&
              activeToken && {
                'Authorization': `Bearer ${activeToken}`,
              }),         
              ...(cookieUID && {
              'UID': cookieUID,
            }),
          },
          ...(abortControllerSignal && {'signal':abortControllerSignal}), 
          
        })
          .then((res) => res.data)
          .catch((err) => {

            if (axios.isCancel(err) || axios.isCancel(err)?.code) {
              // request was intercepted by a signal cancellation
              return Promise.reject({code: 'axios_cancelled', data: {}});
            }

            const errorObj = err.response;
            console.error('errorObj>>',errorObj);
            switch (errorObj?.status) {
              case 401: {
                if(owner){
                  
                  this.useLocalStorage({
                    type: 'set',
                    value: {},
                    key: owner,
                  });

                  if(owner === MAINROLES.user){
                    this.$router?.push(ROUTESNAMES.user.login);
                    this.notify({
                      type: 'error',
                      msg: this.$t('general.not_authorized')
                    })
                  }else if(owner === MAINROLES.admin){
                    if(currentAdminType === SPECIFICROLES.reseller || SPECIFICROLES.moderator_reseller){
                      this.$router.push({path: ROUTESNAMES.user.login});
                      this.notify({
                        type: 'error',
                        msg: this.$t('general.not_authorized')
                      })
                    }else{
                      this.$router?.push(ROUTESNAMES.panel.login);
                      this.notify({
                        type: 'error',
                        msg: this.$t('general.not_authorized')
                      })
                    }
                  }
                }else{
                  this.$router.push(ROUTESNAMES.user.login);
                  this.notify({
                    type: 'error',
                    msg: this.$t('general.not_authorized')
                  })
                }

                // if (owner === MAINROLES.user) {
                //   this.$router.push(ROUTESNAMES.user.login);
                // }else if(specificRole === SPECIFICROLES.reseller || specificRole === SPECIFICROLES.moderator_reseller){
                //   this.$router.push({path: ROUTESNAMES.user.login});
                // }else if(owner === MAINROLES.admin){
                //   this.$router.push({path: ROUTESNAMES.panel.login});
                // }else {
                //   this.$router.push(ROUTESNAMES.user.login);
                // }
                break;
              }
              // case 400: {
              //     this.$router.push(ROUTESNAMES.errors._400);
              //     break;
              // }
              // case 403: {
              //     this.$router.push(ROUTESNAMES.errors._403);
              //     break;
              // }
              // case 404: {
              //     this.$router.push(ROUTESNAMES.errors._404);
              //     break;
              // }
              // case 500: {
              //     this.$router.push(ROUTESNAMES.errors._500);
              //     break;
              // }
              case 503: {
                this.$router.push(ROUTESNAMES.errors._503);
                break;
              }
              default:
                () => {};
            }
            return Promise.reject(errorObj || {});
          });

    },
    isEmpty(v){
      if(Array.isArray(v)){
        return v.length==0?true:false
      }else if(typeof(v)=='object'){
        return Object.keys(v).length==0?true:false
      }else{
        console.error("argument in function isEmpty() is not an type of  array or object ")
        return true
      }
    },
    scrollToErrorBox(){
      this.$nextTick(() => {
        // make sure you have the class '.error_message' in your error element
        const firstErrorMessage = document.querySelectorAll('.error_message')?.[0];
        if(firstErrorMessage){
          firstErrorMessage.scrollIntoView({block: 'center', behavior: 'smooth'});
        }else{
          return;
        }
      });
    },
    handleImageError(e,type='rounded') {
      e.target.src =type=='rounded'? roundedPlaceholderImg:rectanglePlaceholderImg
      e.onerror = null;
      return true;
    },
    handelControlPanel({redirectToPanelPage='homepage',appendToPath='',}) {
      //first copy user info in localstorege to admin info
      let user = this.useLocalStorage({ type: 'get', key: 'user' });
      (user?.role == this.SPECIFICROLES.reseller||user?.role == this.SPECIFICROLES.moderator_reseller) && this.useLocalStorage({ type: 'set', key: 'admin', value: { ...user } });
    
      //then go to  reseller or sub-reseller panel
        user?.role == this.SPECIFICROLES.reseller && this.$router.push(`${ this.ROUTESNAMES.reseller[redirectToPanelPage] }${appendToPath}`);
        user?.role == this.SPECIFICROLES.moderator_reseller && this.$router.push(`${ this.ROUTESNAMES.moderator_reseller[redirectToPanelPage] }${appendToPath}`);
      
    },
    handleNotificationActions(actionType,type_id=''){
      switch (actionType) {
        case 'welcome_message':
          break;
        case 'new_order':
          this.handelControlPanel({redirectToPanelPage: 'orders',})
          break;
        case 'change_order_status':
          this.$router.push(this.ROUTESNAMES.user.orders);
          break;
        case 'chat_message':
          this.$router.push(`${this.ROUTESNAMES.user.chats}?id=${type_id}`);
          break;
        case 'products_following':
          this.$router.push(`${this.ROUTESNAMES.user.products}/store/${type_id}/product`);
          break;
        case 'warning':
        case 'product_deleted_admin':
          this.contentModal = true;
          break;
        case 'product_archived_admin':
          this.archivedProductByAdminModal = true;
          break;
        case 'archive_product_5':
        case 'archive_product_3':
        case 'archive_product_1':
          this.archivedModal = true;
          break;
        case 'general':
          this.generalNotificationModal = true;
          break;
        case 'store_expired':
        case 'store_expiration':
          type_id?
          this.handelControlPanel({redirectToPanelPage: 'package_invoices',appendToPath: `?store=${type_id}`})
          :
          this.handelControlPanel({redirectToPanelPage: 'stores',})
          break;
        case 'order_product_removed_by_user':
          this.orderProductRemovedByUserModal = true;
          break;
        case 'order_product_removed_by_reseller':
          this.orderProductRemovedByResellerModal = true;
          break;
        case 'withdrawal_request':
          // Open modal - redirect happens when clicking the link in the modal
          this.withdrawalRequestModal = true;
          break;
        case 'withdrawal_accepted_cezma_wallet':
        case 'withdrawal_accepted_mobile_wallet':
        case 'withdrawal_rejected':
        case 'withdrawal_accepted':
          this.withdrawalNotificationModal = true;
          break;
        default:
      }
    },

  },
};
